<template>
  <div>
    <Nav></Nav>
    <mdb-container class="my-4 mt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left">
          <h1 class="h1">Discussions in: {{categoryname}}</h1>
        </mdb-col>
      </mdb-row>
      <mdb-row class="my-3">
        <mdb-col sm="12" lg="3" class>
          <!--<div class="community-cat-list" v-if="!startADiscussionMode">-->
          <div class="community-cat-list">
            <ul>
              <li class="back">
                <router-link :to="backToCategories()">
                  <mdb-icon icon="long-arrow-alt-left" class="list-icon" />Back to categories
                </router-link>
              </li>
              <!-- static list on the left -->

              <li v-for="c in categoriesstatic" v-bind:key="c">
                <router-link :to="c | hrefize" v-bind:class="methodActivize(c)">
                  <mdb-icon icon="square" class="list-icon" />
                  <span>{{c}}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <mdb-btn
            v-if="!startADiscussionMode"
            @click="mthStartADiscussionButtonClick"
            color="primary"
            size="sm"
            class="m-0 mb-5 btn-ssm d-block"
          >Start a discussion</mdb-btn>
        </mdb-col>
        <mdb-col sm="12" lg="9" class>
          <!-- add new discussion -->
          <div v-if="startADiscussionMode==true" class="new-discussion">
            <!--<div class="discussion-list-item-author">
              <span class="avatar">:-)</span>
            </div>-->
            <div class>
              <div class="add">
                <input class v-model="addNewDiscussionName" placeholder="Name of the discussion" />
                <!--<div class="discussion-list-item-tags">
                  <mdb-badge v-if="false" pill color="black">{{getUserName}}</mdb-badge>
                  <div class="discussion-list-item-reply">
                    <strong>{{getUserName}}</strong>
                    is creating a discussion now!
                  </div>
                  <a class="discussion-list-item-like">
                    <mdb-btn @click="mthAddNewDiscussionOKSAVEbuttonClicked" color="primary" size="sm">OK</mdb-btn>
                    <mdb-icon icon="comment" />
                    <span>0</span>
                  </a>
                </div>
                <div class="discussion-list-item-excerpt"></div>-->
                <mdb-btn
                  @click="mthAddNewDiscussionOKSAVEbuttonClicked"
                  color="primary"
                  size="sm"
                  class="save"
                >Add</mdb-btn>
              </div>
            </div>
          </div>

          <!-- list of discussions -->
          <div class>
            <div class="discussion-list-item" v-for="d in discussionstoloopfor" :key="d.fireid">
              <AvatarFromProfileByEmail :email="d.top1replyobj.who" :key="'aa'+refresher"></AvatarFromProfileByEmail>
              <div class="discussion-list-item-main">
                <div class="brief">
                  <router-link :to="methodComposeLinkToDiscussionDetail(d.fireid)">
                    <h3>{{d.discussionname}}</h3>
                    <div class="discussion-list-item-tags">
                      <mdb-badge pill color="grey">{{d.category}}</mdb-badge>
                      <div class="discussion-list-item-reply">
                        <strong>{{ d.top1replyobj.who }}</strong>
                        replied {{ methodTimeSecondsHumanize(d.top1replyobj.when.seconds) }}
                      </div>
                      <a class="discussion-list-item-like">
                        <mdb-icon icon="comment" />
                        <span>{{d.repliescounter.counter}}</span>
                      </a>
                    </div>
                    <div class="discussion-list-item-excerpt" v-html="d.top1replyobj.what"></div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import AvatarFromProfileByEmail from "../components/AvatarFromProfileByEmail";
import firebase from "firebase";
import moment from "moment";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon
} from "mdbvue";
import { isNumber } from "util";

export default {
  name: "Community",
  data() {
    return {
      refresher: 0,
      categoryname: "All Categories",
      categoriesstatic: [
        "How to find clients",
        "How to sell and win",
        "How to sell more",
        "Tell us what you like",
        "10 Critical Sales Skills",
        "Technical help and Support"
      ],
      discussionstoloopfor: [],
      topreplieswhowhatwhen: [],
      startADiscussionMode: false,
      addNewDiscussionName: ""
    };
  },

  created: function() {
    // console.log('created fired');
    // console.log(this.$router)
    // console.log(this.$router.params)
    var that = this;

    this.categoryname = this.$router.currentRoute.params.categoryname
      .replace("-", " ")
      .replace("-", " ")
      .replace("-", " ")
      .replace("-", " ")
      .replace("-", " ");

    //fill data object onsnapshot
    var refdiscussionsincategory = firebase
      .firestore()
      .collection("forumdiscussions")
      .where(
        "category",
        "==",
        this.routerToHuman(this.$router.currentRoute.params.categoryname)
      )
      .orderBy("dateCreated", "desc");

    refdiscussionsincategory.onSnapshot(querySnapshot => {
      //console.log("onSnapshot fired ");

      this.discussionstoloopfor = []; //clear to not stack after snapshot...
      querySnapshot.forEach(doc => {
        //console.log("pushing " + doc.data().discussionname);

        this.discussionstoloopfor.push({
          fireid: doc.id,
          discussionname: doc.data().discussionname,
          category: doc.data().category,
          top1replyobj: this.methodGetReplyObj(doc.id),
          repliescounter: this.methodCountRepliesForDiscussion(doc.id)
        });
      });
    });
  },
  computed: {
    getUserName: function() {
      return this.$store.getters.getUser
        ? this.$store.getters.getUser.email
        : "null";
    }
  },
  methods: {
    mthCapitalizeFLetter(input) {
      return input.charAt(0).toUpperCase() + input.slice(1);
    },
    mthAddNewDiscussionOKSAVEbuttonClicked() {
      var name = this.addNewDiscussionName;
      //var categoryname=this.$router.currentRoute.params.categoryname;
      var categoryname = this.mthCapitalizeFLetter(this.categoryname);

      var dateCreated = new Date();

      firebase
        .firestore()
        .collection("forumdiscussions")
        .add({
          category: categoryname,
          discussionname: name,
          dateCreated: dateCreated
        })
        .then((this.startADiscussionMode = false));
    },
    mthStartADiscussionButtonClick() {
      this.startADiscussionMode = true;
    },
    methodTimeSecondsHumanize(seconds) {
      if (isNumber(seconds)) return moment.unix(seconds).toNow() + " ago";

      return "";
    },
    methodCountRepliesForDiscussion(fireid) {
      var obj = {
        counter: 0
      };

      var result = firebase
        .firestore()
        .collection("forumdiscussionsdetails")
        .where("discussionid", "==", fireid)
        //.orderBy("timestamp", "desc")
        //.limit(1)
        .get()
        .then(function(querySnapshot) {
          //console.log(querySnapshot.size);
          obj.counter = querySnapshot.size;
        });

      return obj;
    },
    methodGetReplyObj(fireid) {
      var that = this;

      var obj = {
        fireid: fireid,
        who: "",
        what: "",
        when: ""
      };

      var result = firebase
        .firestore()
        .collection("forumdiscussionsdetails")
        .where("discussionid", "==", fireid)
        .orderBy("timestamp", "desc")
        .limit(1)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //console.log(doc);
            obj.fireid = doc.id;
            obj.who = doc.data().whosaidthis;
            obj.what = doc.data().detailtext;
            obj.when = doc.data().timestamp;

            that.refresher++;
          });
        });

      //this.topreplieswhowhatwhen.push(obj);

      return obj;
    },
    // getReplyObj(fireid) {
    //   var self = this;
    //   var who = "";
    //   var what = "";
    //   var when = "";

    //   var result = firebase
    //     .firestore()
    //     .collection("forumdiscussionsdetails")
    //     .where("discussionid", "==", fireid)
    //     .orderBy("timestamp", "desc")
    //     .limit(1)
    //     .get();

    //   result.then(function(value) {
    //     console.log(value.data().whoreplied);

    //     self.who = value.whoreplied;
    //   });

    //   return {
    //     whoreplied: self.who,
    //     whatsaid: what,
    //     when: when
    //   };

    //   // result.forEach(doc=> {
    //   //   console.log(doc.data());

    //   //   console.log('now pushing ' + doc.data().whosaidthis);

    //   //   who = doc.data().whosaidthis;
    //   //   what = doc.data().detailtext;
    //   //   when = doc.data().timestamp;

    //   //   console.log(self.who);

    //   // });
    //   //   });
    // },
    backToCategories() {
      return "/community";
    },
    changeCategory(cat) {
      console.log(cat);
      cat = cat
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-")
        .replace(" ", "-");
      //this.$router.replace("/community/community-list-discussions/" + cat);
      return "/community/community-list-discussions/" + cat;
    },
    routerToHuman: function(routerstring) {
      //console.log('routerToHuman says: '+routerstring);

      if (!routerstring) return "";

      var ret = routerstring;

      ret = ret
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ");

      ret = ret.charAt(0).toUpperCase() + ret.slice(1);

      return ret;
    },
    methodActivize: function(c) {
      // console.log(
      //   "methodActivize says c=" + c + ", categoryname=" + this.categoryname
      // );

      c = c
        //.toLowerCase()
        .replace("-", "")
        .replace("-", "")
        .replace("-", "")
        .replace("-", "")
        .replace("-", "")
        .replace("-", "");

      if (c == this.categoryname) return "active";

      return "";
    },
    methodComposeLinkToDiscussionDetail: function(discussionid) {
      return "/community/community-discussion/" + discussionid.toString();
    }
  },
  filters: {
    hrefize: function(value) {
      if (!value) return "";
      value = value.toString();
      return (
        value
          //.toLowerCase()
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
          .replace(" ", "-")
      );
    }
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    AvatarFromProfileByEmail
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
.newDiscussionInput {
  font-weight: bold;
  font-size: 1.5rem;
  color: green;
  background-color: yellow;
  width: 80%;
}
</style>
